import { useCallback } from 'react';
import { clearStorageSession, isAlreadyAuthorized, removePtpIgnored, removeRegTypeItem } from 'utils';
import { useAppDispatch } from 'store/hooks';
import { cleanupUser, updateUserAuthentication } from 'store/slices/user';
import { cleanupLoan } from 'store/slices/loan';
import { cleanupUi } from 'store/slices/ui';
import { cleanupCalculation } from 'store/slices/calculation';
import { cleanupPaymentCards } from 'store/slices/payment';
import { clearFeatureFlagsCache } from './useFeatureFlags';

export const useClearAllOnLogout = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    if (isAlreadyAuthorized()) {
      clearStorageSession();
      dispatch(cleanupUser());
      dispatch(cleanupLoan());
      dispatch(cleanupUi());
      dispatch(cleanupCalculation());
      dispatch(cleanupPaymentCards());
      dispatch(updateUserAuthentication(false));
      removePtpIgnored();
      removeRegTypeItem();
      clearFeatureFlagsCache();
    } else {
      clearStorageSession();
    }
  }, [dispatch]);
};
